"use client";

import { Components } from "@/app/(components)/_components/Components";
import ActionMenu from "@/app/(components)/generics/ActionMenu/ActionMenu";
import IconDownload from "@/app/(components)/generics/Icons/IconDownload";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKeyClientAvatar as TKey } from "@/app/translations/keys/TKeyClientAvatar";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";

type Props = DefaultProps & {
  offerId: number;
};

export default function ClientAvatarMenu(props: Props) {
  const T = useT();
  const { params, offerId } = props;

  const handleExportAvatars = () => {
    ModalStore.getState().openModal(
      Components.ExportAvatar,
      T(TKey.CLIENT_AVATAR_EXPORT_TITLE) as string,
      { params, offerId },
    );
  };

  return (
    <ActionMenu
      items={[
        {
          icon: <IconDownload size={15} />,
          label: T(TKey.CLIENT_AVATAR_EXPORT_TITLE) as string,
          onClick: handleExportAvatars,
        },
      ]}
    />
  );
}
